import {
  IAnalyticsConnectionMetadata, IAnalyticsExtWorkbookId
} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IGetItemsResult } from '../../../../types/IGetItemsResult';
import { TagRequest } from '../../../TagRequest';

export interface IGetAnalyticsConnectionOptionsForWorkbookResult extends IGetItemsResult {
  connectionMetadataList: IAnalyticsConnectionMetadata[];
}

export class GetAnalyticsConnectionOptionsForWorkbookRequest extends TagRequest<{}, IGetAnalyticsConnectionOptionsForWorkbookResult> {
  constructor(WorkbookId: IAnalyticsExtWorkbookId) {
    super('analyticsextensions', 'getConnectionOptionsForWorkbook', WorkbookId);
  }
}
